@use '@/styles/tokens' as *;

/* Figma 787:681184 — top right of the map area, 8px between pills.
 *
 * The RIGHT inset is 63px, measured in 787:678835, which `<MapControlStack>` already rounds to
 * $space-16 — so the legend's right edge and the zoom controls' right edge line up by construction.
 *
 * D-01: the TOP inset is 23px below the nav's own bottom edge (measured against the full-bleed
 * frame, Figma 2074:1601392) — the Map is full-bleed now, so this finally applies without
 * double-counting the bar. 83px (<TopNav>'s own height: 27px top padding + 56px bar) + 23px = 106,
 * off the `--space-*` scale, same as `.topControls`'s own two numbers.
 *
 * Absolute inside `.mapArea`, NOT inside the map: that is what keeps the legend fixed while the
 * Grower pans and zooms (113584 §4a). `z-index: 2` matches the control stack — above the canvas,
 * far below antd's 1000 overlay base so a ticket-14 modal still renders over it.
 *
 * `MAP_LEGEND_LAYOUT` in src/lib/maps/control-zones.ts repeats these four numbers — SCSS cannot
 * import TS, so the two sides name each other. Change one, change both. */
.legend {
  position: absolute;
  top: 106px;
  inset-inline-end: var(--space-16);
  z-index: 2;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

/* Figma 787:681185 / 787:681189 — 26px dark translucent pill. Radius 16px has no token;
 * $radius-pill renders identically at this height. Figma's 5px vertical padding is off the
 * --space-* scale, so it is dropped in favour of the fixed height plus centring, which round-trips
 * to the same box — the substitution map-control-stack.module.scss already made for its 36px
 * square. Geist 11px has no $font-size-* token either; a raw 11px is the shipped convention where
 * the scale has no step (see upload.module.scss). */
.item {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  height: 26px;
  margin: 0;
  padding-inline: var(--space-2);
  border-radius: $radius-pill;
  background: var(--overlay-60);
  font-size: 11px;
  line-height: 1;
  color: var(--text-inverse);
  white-space: nowrap;
}
